import Cookies from "js-cookie";

/**
 * Cookie Plugin using Alpine
 * ------------------------------------
 * Cookie name is read from the [data-cookie-name] attribute on the wrapper element.
 * Defaults to '__ah__accept-cookies' if not set.
 *
 * Access from other components via $store.cookieConsent
 * eg. $store.cookieConsent.cookiesAgreed
 *
 * Example
 * -------
 * document.addEventListener("__cookies__ok", function(event) { // Insert GA script here });
 *
 */

document.addEventListener("alpine:init", () => {

	window.Alpine.store('cookieConsent', {
		show: false,
		cookiesAgreed: false,
		cookieName: '__ah__accept-cookies',
		eventName: '__cookies__ok',
		labels: {
			// Not needed if using ACF
			title: 'Cookies',
			message: 'Hey we need cookies',
			buttons: {
				accept: 'Accept',
				deny: 'Reject'
			}
		},
		expires: 90,
		init() {
			const el = document.querySelector('[data-cookie-name]');
			if (el) this.cookieName = el.dataset.cookieName;

			this.show = !sessionStorage.getItem(this.cookieName) && !Cookies.get(this.cookieName);
			if (Cookies.get(this.cookieName)) {
				this.cookiesAgreed = true;
				window.dispatchEvent(new CustomEvent(this.eventName));
			}

			window.addEventListener('keydown', (e) => {
				if (e.key === 'Escape' && this.show) this.refuseCookies(true);
			});
		},
		acceptCookies() {
			Cookies.set(this.cookieName, true, { expires: this.expires });
			window.dispatchEvent(new CustomEvent(this.eventName));
			this.show = false;
			this.cookiesAgreed = true;
		},
		refuseCookies(destroy = false) {
			sessionStorage.setItem(this.cookieName, false);
			this.show = false;
			if (destroy) {
				Cookies.remove(this.cookieName);
			}
		},
		get acceptLabel() {
			return this.labels.buttons.accept;
		},
		get denyLabel() {
			return this.labels.buttons.deny;
		}
	});

});
